import { Source } from '../types/chat';

const UUID_V4_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const isUuidV4String = (value: string): boolean => UUID_V4_REGEX.test(value.trim());

/** True when the label is only an id (raw UUID, `file_<uuid>`, or same as fileId). */
export const isUnlabeledSourceName = (fileName: string, fileId?: string): boolean => {
  const name = fileName.trim();
  if (isUuidV4String(name)) {
    return true;
  }
  if (name.startsWith('file_') && isUuidV4String(name.slice(5))) {
    return true;
  }
  if (fileId && name === fileId.trim() && isUuidV4String(fileId.trim())) {
    return true;
  }
  return false;
};

export const getDisplayableSources = (sources: Source[]): Source[] =>
  sources.filter((source) => !isUnlabeledSourceName(source.fileName, source.fileId));
